

(function () {
  'use strict';

  if (!customElements.get('cerus-hero')) {
    customElements.define('cerus-hero', class extends HTMLElement {
      connectedCallback() {

        requestAnimationFrame(function () { initHero(this); }.bind(this));
      }
      disconnectedCallback() {
        if (this._splide) {
          try { this._splide.destroy(); } catch (e) {  }
          this._splide = null;
        }
      }
    });
  }

  function reveal(slide) {
    if (!slide || slide.classList.contains('is-ready')) return;

    slide.offsetHeight;
    slide.classList.add('is-ready');
  }

  function initHero(hero) {
    if (!hero || hero._initialized) return;
    var slides = hero.querySelectorAll('.cerus-hero__slide');
    if (!slides.length) return;

    var isCarousel = hero.classList.contains('cerus-hero--carousel');

    if (isCarousel && window.Splide) {
      var interval   = parseInt(hero.dataset.interval, 10) || 6;
      var autoplay   = hero.dataset.autoplay === 'true';
      var pagination = hero.dataset.pagination !== 'false';


      var splide = new window.Splide(hero, {
        type: 'fade',
        rewind: true,
        perPage: 1,
        speed: 700,
        easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
        autoplay: autoplay,
        interval: interval * 1000,
        pauseOnHover: true,
        pauseOnFocus: true,
        arrows: false,
        pagination: false,
        drag: true,
        flickPower: 360
      });

      splide.on('mounted', function () { reveal(slides[0]); });

      splide.on('active', function (slide) {
        reveal(slide.slide);
        var video = slide.slide.querySelector('.cerus-hero__bg-video');
        if (video) { try { video.currentTime = 0; video.play(); } catch (e) {  } }
      });

      splide.on('inactive', function (slide) {
        var video = slide.slide.querySelector('.cerus-hero__bg-video');
        if (video) { try { video.pause(); } catch (e) {  } }
      });

      splide.mount();
      hero._splide = splide;

      var prevBtn = hero.querySelector('[data-cerus-hero-prev]');
      var nextBtn = hero.querySelector('[data-cerus-hero-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { splide.go('<'); });
      if (nextBtn) nextBtn.addEventListener('click', function () { splide.go('>'); });

      var pagEl = hero.querySelector('[data-cerus-hero-pagination]');
      if (pagination && pagEl) {
        var totalSlides = slides.length;

        pagEl.style.setProperty('--cerus-hero-progress-duration', interval + 's');
        for (var p = 0; p < totalSlides; p++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cerus-hero__dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (p + 1));
          dot.dataset.index = String(p);
          var fill = document.createElement('span');
          fill.className = 'cerus-hero__dot-fill';
          dot.appendChild(fill);
          if (p === 0) dot.classList.add('is-active');
          dot.addEventListener('click', function (e) {
            var idx = parseInt(e.currentTarget.dataset.index, 10);
            splide.go(idx);
          });
          pagEl.appendChild(dot);
        }
        splide.on('move', function (newIndex) {
          var dots = pagEl.querySelectorAll('.cerus-hero__dot');
          dots.forEach(function (d) { d.classList.remove('is-active'); });
          var nextDot = dots[newIndex];
          if (nextDot) {

            void nextDot.offsetWidth;
            nextDot.classList.add('is-active');
          }
        });
      }

      var ppBtn = hero.querySelector('[data-cerus-hero-playpause]');
      if (ppBtn) {

        var initialState = autoplay ? 'playing' : 'paused';
        ppBtn.dataset.state = initialState;
        ppBtn.setAttribute('aria-pressed', autoplay ? 'false' : 'true');
        ppBtn.setAttribute('aria-label', autoplay ? 'Pause slideshow' : 'Play slideshow');

        ppBtn.addEventListener('click', function () {
          var ap = splide.Components.Autoplay;
          if (!ap) return;
          if (ppBtn.dataset.state === 'playing') {
            ap.pause();
            ppBtn.dataset.state = 'paused';
            ppBtn.setAttribute('aria-pressed', 'true');
            ppBtn.setAttribute('aria-label', 'Play slideshow');
          } else {
            ap.play();
            ppBtn.dataset.state = 'playing';
            ppBtn.setAttribute('aria-pressed', 'false');
            ppBtn.setAttribute('aria-label', 'Pause slideshow');
          }
        });
      }

      if (autoplay && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) splide.Components.Autoplay.play();
            else                       splide.Components.Autoplay.pause();
          });
        }, { threshold: 0.2 });
        io.observe(hero);
      }
    } else {

      if ('IntersectionObserver' in window) {
        var single = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              single.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        slides.forEach(function (s) { single.observe(s); });
      } else {
        slides.forEach(reveal);
      }
    }

    hero._initialized = true;
  }

  if (window.Shopify && Shopify.designMode) {
    var pickHero = function (sectionId) {
      return document.querySelector('#shopify-section-' + sectionId + ' cerus-hero');
    };

    var jumpToSlide = function (hero, blockId) {
      if (!hero || !hero._splide) return;
      var slides = hero.querySelectorAll('.cerus-hero__slide');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.shopifyEditorBlock && slides[i].dataset.shopifyEditorBlock.indexOf(blockId) !== -1) {
          hero._splide.go(i);
          break;
        }
      }
    };

    document.addEventListener('shopify:section:load', function (e) {
      var hero = e.target.querySelector('cerus-hero');
      if (hero) initHero(hero);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var hero = e.target.querySelector('cerus-hero');
      if (hero && hero._splide) {
        try { hero._splide.destroy(); } catch (err) {  }
        hero._splide = null;
        hero._initialized = false;
      }
    });

    document.addEventListener('shopify:section:select', function (e) {
      var hero = e.target.querySelector('cerus-hero');
      if (hero && hero._splide) hero._splide.Components.Autoplay.pause();
    });

    document.addEventListener('shopify:section:deselect', function (e) {
      var hero = e.target.querySelector('cerus-hero');
      if (hero && hero._splide && hero.dataset.autoplay === 'true') {
        hero._splide.Components.Autoplay.play();
      }
    });

    document.addEventListener('shopify:block:select', function (e) {
      var hero = pickHero(e.detail.sectionId);
      if (hero && hero._splide) {
        hero._splide.Components.Autoplay.pause();
        jumpToSlide(hero, e.detail.blockId);
      }
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      var hero = pickHero(e.detail.sectionId);
      if (hero && hero._splide && hero.dataset.autoplay === 'true') {
        hero._splide.Components.Autoplay.play();
      }
    });
  }
})();
